import _ from "lodash";
import { Wallet } from "../../../assets/whiteLabelIcon";
import ImageLinks from "../../../assets/Images/ImagesLink";
import Footer from "../../../Footer";
import { formatCurrencyCountry } from "../../../resources/internationalizationUtils";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function CartPaymentDetails({
  total_amount,
  create_order,
  btn_disable,
  is_error_wallet,
  wallet,
}) {
  const userDetails = useSelector((state) => state.app.user_details);
  const currency_code = userDetails?.currency || "DEFAULT";
  const { t } = useTranslation();

  return (
    <div className="shadow-[0px_-6px_16.7px_0px_#F2F2F2]  left-0 right-0 fixed bottom-[0px] bg-white">
      {!is_error_wallet ? (
        <div className="flex px-12 pt-4 justify-between items-center">
          <div className="text-stone-900 text-xs font-semibold">
            {t("total_amount")}
          </div>
          <div className="text-base font-semibold text-secondary">
            {
              formatCurrencyCountry(total_amount || 0, currency_code)
                .formatedAmount
            }
          </div>
        </div>
      ) : (
        <div className="flex px-12 pt-6 justify-center items-center">
          <img
            alt="icon"
            src={ImageLinks.info_circle_red}
            className="h-4 text-error"
          />
          <p className="text-xs mx-1">{t("low_balance")}</p>
        </div>
      )}
      <div className="flex flex-col gap-2 px-12 mb-10 items-center">
        <button
          className={`relative font-custom flex w-full mt-4 py-4 px-4 items-center rounded-full shadow-lg justify-center
            ${
              btn_disable
                ? "bg-gray text-gray-200 cursor-not-allowed"
                : "bg-primary text-white"
            }`}
          onClick={create_order}
          disabled={btn_disable}
        >
          <div className="absolute left-[10px] bg-white rounded-full p-2">
            <Wallet />
          </div>
          <p className="font-custom text-base font-bold">
            {" "}
            {is_error_wallet ? t("add_money") : t("pay_via_wallet")}
          </p>
        </button>

        {!is_error_wallet ? (
          <p className="font-custom text-[10px] font-medium text-secondary">
            {t("wallet_bal")}:{" "}
            {
              formatCurrencyCountry(wallet?.balance || 0, currency_code)
                .formatedAmount
            }
          </p>
        ) : (
          <p className="font-custom text-[10px] font-medium text-error">
            {t("wallet_bal")}: ₹{" "}
            {
              formatCurrencyCountry(wallet?.balance || 0, currency_code)
                .formatedAmount
            }
          </p>
        )}
      </div>
      <Footer bottom={0} />
    </div>
  );
}

export default CartPaymentDetails;
